import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ActionType,
  WorkflowActionType,
} from '../../../../../core/models/action.model';
import {
  Notification,
  NotificationType,
} from '../../../../../core/models/notification.model';
import { EndState } from '../../../../../core/models/workflow.model';

@Component({
  selector: 'irembogov-notification-configuration-list',
  templateUrl: './notification-configuration-list.component.html',
  styleUrls: ['./notification-configuration-list.component.scss'],
})
export class NotificationConfigurationListComponent {
  @Input() notifications: Notification[] = [];
  @Output() add = new EventEmitter<void>();
  @Output() edit = new EventEmitter<Notification>();
  @Output() delete = new EventEmitter<Notification>();

  getEndStateTypeDisplay(type: string): string {
    switch (type) {
      case EndState.END_STATE_ONE:
        return 'End State One';
      case EndState.END_STATE_TWO:
        return 'End State Two';
      default:
        return type;
    }
  }

  getActionTypeDisplay(actionType: ActionType): string {
    switch (actionType) {
      case WorkflowActionType.BREAKING_ACTION:
        return 'Breaking Action';
      case WorkflowActionType.BREAKING_ACTIONS:
        return 'Breaking Actions';
      case WorkflowActionType.NON_BREAKING_ACTIONS:
        return 'Non-Breaking Actions';
      default:
        return actionType;
    }
  }

  getNotificationTypeDisplay(type: NotificationType): string {
    switch (type) {
      case NotificationType.STATIC:
        return 'Static';
      case NotificationType.NOTIFICATION_ENGINE_TEMPLATE:
        return 'Notification Engine Template';
      default:
        return type;
    }
  }

  onAddNew() {
    this.add.emit();
  }

  onEdit(notification: Notification) {
    this.edit.emit(notification);
  }

  onDelete(notification: Notification) {
    this.delete.emit(notification);
  }
}
